import {Environment, EnvironmentMode} from '../shared/environment-types';

let absoluteUrl = document.getElementsByTagName('base')[0].href + "/webapis";

if (document.getElementsByTagName('base') != null && document.getElementsByTagName('base')[0] != null && document.getElementsByTagName('base')[0].getAttribute('data-api')) {
	absoluteUrl = document.getElementsByTagName('base')[0].getAttribute('data-api');
}
else {
	absoluteUrl = absoluteUrl.replace(document.getElementsByTagName('base')[0].href + "/", document.getElementsByTagName('base')[0].href);
}

const environmentName: string = 'STAGING';

export const environment: Environment = {
	appVersion: `${require('../../package.json').version}-${environmentName}`,
	mode: EnvironmentMode.STAGING,
	environmentName: environmentName,
	apiEndpoint: absoluteUrl,

	mapbox: {
		accessToken: "pk.eyJ1IjoicGVyaXRvY29uc3VsdGluZyIsImEiOiJjbDQ0Nmg4bTYwM243M2pvaXJkaXdyeG9qIn0.c1t-d6KHOqabhjcLDdEqZQ"
	},

	devExtreme: {
		licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjU2MWM1ZTYyLWNjZTktNDg4MC04NTg0LTE3ZTk2YmIyNTk0NSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.m9jxi5eyKW4CW+ZS1+A33p0LzzMpGSr+vatZlZRxW2WOdeY4+s7qCiKVXsTYOqjIIbki2hoIsFVipg+hRofAW5L226QLh2nw3lBUJ3szV3ebsOnfUfTJkIKno2eplL0kJNnoWw=='
	},
};
